<template lang="pug">
  div
    table.table.mar_b--10
      tr
        td: strong.bold__semi
          small: font-awesome-icon(icon="angle-right")
          span.pad_l--10 Transaction limits
      tr
        td
          | The transaction limit is subject to the your internet banking limit with your bank. In general,
          ul.list--unordered.list--unordered_circle
            li For retail/personal banking account, the minimum limit per transaction is RM1.00 and maximum amount is limited up to RM30,000 per transaction.
            li For company/corporate banking, the minimum limit per transaction is RM2.00 and maximum amount is limited up to RM1,000,000” per transaction.

      tr
        td: strong.bold__semi
          small: font-awesome-icon(icon="angle-right")
          span.pad_l--10 Processing time
      tr
        td
          ul.list--unordered.list--unordered_circle
            li Trading limit will be given upon verification and confirmation of the FPX transaction.
            li It will be processed between 7am – 7pm during working day.
            li For those FPX transaction that falls other than the above stipulated time, it will be processed in the next working day.

      tr
        td: strong.bold__semi
          small: font-awesome-icon(icon="angle-right")
          span.pad_l--10 Admin Fees &amp; charges
      tr
        td
          ul.list--unordered.list--unordered_circle
            li There are FPX transfer fees and charges which are ranging from RM0.50 ~ RM 1.00 (it depends on type of client’s bank account).
            li However, Affin Hwang Investment Bank will absorb the above FPX transfer fees &amp; charges.

      tr
        td: strong.bold__semi
          small: font-awesome-icon(icon="angle-right")
          span.pad_l--10 Who is eligible
      tr
        td
          | At the moment, Affin Hwang Investment Bank only offers this features to Cash Management Account [CMA] and Cash Management Account (Shariah) [CMA-i] clients.

    .ehgl--poweredby
      | Payment gateway powered by 
      img.ehgl--logo(src='../assets/images/eghl_logo.png', alt="")

</template>



<script>


export default {
  name: 'FPXTnC',
}

</script>




<style lang="scss">
  .ehgl--poweredby {
    @include font-size($text-size-13);
    line-height: 20px;
    color: $color-body_grey;
  }
  .ehgl--logo {
    max-height: 14px;
    margin: -5px 0 0 5px;
  }
</style>
